import { z } from "zod";
import { id, pageInput } from "./common";

/** What lands in someone's inbox. */
export const NOTIFICATION_KINDS = [
  "mention",
  "task_assigned",
  "brief_to_decide",
  "brief_clarification",
  "brief_accepted",
  "change_request_raised",
  "change_request_resolved",
  "change_request_reopened",
  "campaign_assigned",
] as const;
export type NotificationKind = (typeof NOTIFICATION_KINDS)[number];

/** Reads after the actor's name and before the campaign's: "Asha mentioned you on Diwali". */
export const NOTIFICATION_PHRASES: Record<NotificationKind, string> = {
  mention: "mentioned you",
  task_assigned: "gave you a task",
  brief_to_decide: "submitted a brief for you to decide",
  brief_clarification: "has questions about the brief",
  brief_accepted: "approved the brief",
  change_request_raised: "raised a change request",
  change_request_resolved: "resolved a change request",
  change_request_reopened: "reopened a change request",
  campaign_assigned: "added you to the team",
};

export const listActivityInput = pageInput.extend({ campaignId: id });
export type ListActivityInput = z.infer<typeof listActivityInput>;

export const listNotificationsInput = pageInput.extend({
  unreadOnly: z.boolean().optional(),
});
export type ListNotificationsInput = z.infer<typeof listNotificationsInput>;

export const markNotificationsReadInput = z.object({
  notificationIds: z
    .array(id)
    .min(1)
    .max(100)
    .refine((ids) => new Set(ids).size === ids.length, "Each notification only once"),
});
export type MarkNotificationsReadInput = z.infer<typeof markNotificationsReadInput>;
